export function courseModuls(){
    Alpine.data('modules', () => ({
        is_open: false,
        is_done: false,

        trigger_open: {
            ["@click"](e)  {
                this.is_open = !this.is_open
            },
        },
    }))
}